import { TypedUseSelectorHook, useSelector } from 'react-redux';

import { RootState } from '#store.config';

const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default useAppSelector;
